import Vue from 'vue'
import Vuex from 'vuex'
import languageStore from './modules/locale'
import licenses from './modules/licenses'
import licenseUsages from './modules/licenseusages'
import oidcStore from './modules/oidc'
import orders from './modules/orders'
import users from './modules/users'
import userProfiles from './modules/userprofiles'
import events from './modules/eventlog'
import organizations from './modules/organizations'
import products from './modules/products'
import metadata from './modules/metadata'
import groups from './modules/groups'
import biblioOnix from './modules/biblio-onix'
import sessionStorage from './modules/sessionStorage'
import scheduling from './modules/scheduling'
import subscriptions from './modules/subscriptions'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    languageStore,
    oidcStore,
    orders,
    users,
    userProfiles,
    events,
    organizations,
    licenses,
    licenseUsages,
    products,
    metadata,
    groups,
    biblioOnix,
    scheduling,
    sessionStorage,
    subscriptions
  }
})
